module.exports = __webpack_public_path__ + "static/media/SearchGrey.9da5fdbb.svg";